import styled from "styled-components";

export const Container = styled.div`
    max-width: 1488px;
    padding: 0 24px;
    margin: 85px auto 64px;

    h1 {
    font-size: var(--text-size-md);
    line-height: 28px;
    margin-top: 40px;
}

@media screen and (min-width: 1105px) {
    margin-bottom: 144px;

    h1 {
        line-height: 52px;
        font-size: var(--text-size-xlg);
        margin-top: 80px;
    }
}
`

export const Breadcrumbs = styled.div`
    padding-top: 40px;
    display: flex;
    align-items: center;

    span {
        font-size: var(--text-size-3xs);
        margin: 0 8px;
        color: var(--color-gray-500);
    }

    a {
        font-size: var(--text-size-3xs);
        color: var(--color-gray-500);

        &:last-child {
            color: var(--color-black);
        }
    }
`

export const Contents = styled.section`
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 40px;
  margin-top: 40px;
  align-items: flex-start;

  @media (max-width: 1104px) {
    grid-template-columns: 1fr;
  }
`;

export const BlogCardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 1104px) {
    grid-template-columns: 1fr;
  }
`;

export const FeaturedCardWrapper = styled.div`
  grid-column: span 2;

    .last-posts, .highlight-post {
        font-size: var(--text-size-xlg);
        line-height: 52px;
        font-weight: 700;
        width: 600px;
    }
    .highlight-post {
        margin-bottom: 24px;
    }
    .last-posts {
        margin-top: 24px;
    }

  @media (max-width: 1104px) {
    .last-posts, .highlight-post  {
        font-size: var(--text-size-md);
        line-height: 28px;
        font-weight: 700;
        margin-bottom: 12px;
    }
    .highlight-post {
        margin-bottom: 12px;
    }
    .last-posts {
        margin-top: 12px;
    }
    grid-column: span 1;
  }
`;

export const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SectionInfo = styled.div`
    background: var(--color-white);
    padding-top: 48px;

    div.buttonCenter {
        padding: 0 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 32px;
        gap: 10px;
        flex-wrap: wrap;

        button {
            margin: 0;
        }
    }

    div.text {
        margin: auto;
        padding: 0 24px;
        text-align: center;

        h3,
        h4 {
            font-size: var(--text-size-md);
            line-height: 28px;
            font-weight: 700;
        }

        p {
            font-size: var(--text-size-2xs);
            color: var(--color-gray-600);
            margin-top: 16px;
        }
    }

    @media screen and (min-width: 1105px) {
        padding-top: 48px;

        div.buttonCenter {
            margin-top: 48px;

        } button {
            max-width: 308px;
            height: 64px;
            font-size: var(--text-size-sm);
        }

        div.text {
            margin: auto;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;

            h3 {
                font-size: var(--text-size-xlg);
                line-height: 52px;
                font-weight: 700;
                width: 600px;

                @media screen and (min-width: 1105px) {
                    max-width: 650px;    
                }
            }

            p {
                max-width: 650px;
                font-size: var(--text-size-xs);
                margin-top: 32px;
                width: 754px;
                margin: auto;
                margin-top: 32px;
            }
        }
    }
`

export const PaginationContainer = styled.div`
  grid-column: span 2;

  @media (max-width: 1104px) {
    grid-column: span 1;
  }
`;